/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type ProvidedService = typeof ProvidedService[keyof typeof ProvidedService];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProvidedService = {
  ANT: 'ANT',
  MTG: 'MTG',
  AFD: 'AFD',
  PRG: 'PRG',
  RDP: 'RDP',
  CPB: 'CPB',
  LVR: 'LVR',
  FCR: 'FCR',
  AFRR: 'AFRR',
  MARI: 'MARI',
  EMRGP: 'EMRGP',
  EGC: 'EGC',
  P2P: 'P2P',
  ACP: 'ACP',
  IAC: 'IAC',
} as const;
